import pRetry from "p-retry";
import type { AppStore } from "@/store";
import { logger } from "@/modules/logger";
import { objectModule } from "@/modules/object";
import { readIMessageClaimFlowSession } from "@/modules/mem-agent/imessage-claim-flow-session";

const FLOATING_MEM_ONBOARDING_PREPARE_RETRY_OPTIONS = {
  retries: 2,
  minTimeout: 250,
  maxTimeout: 1000,
};

export const prepareFloatingMemForOnboarding = async ({
  store,
}: {
  store: AppStore;
}): Promise<boolean> => {
  if (readIMessageClaimFlowSession()) {
    // The iMessage claim endpoint owns assistant creation and channel activation.
    // Preparing floating Mem here would upsert Native Chat first and steal onboarding.
    return true;
  }

  try {
    await pRetry(async () => {
      await store.memAgent.setup({ showToast: false });
      if (!store.memAgent.hasAssistant) {
        throw new Error("Mem Agent setup completed without an assistant");
      }
    }, FLOATING_MEM_ONBOARDING_PREPARE_RETRY_OPTIONS);

    await pRetry(
      () => store.pageStore?.floatingAgentPage.ensureSessionForOnboarding(),
      FLOATING_MEM_ONBOARDING_PREPARE_RETRY_OPTIONS
    );
    return true;
  } catch (unknownError) {
    const error = unknownError as Error;

    logger.warn({
      message: "[prepareFloatingMemForOnboarding] Failed to prepare Mem Agent onboarding chat",
      info: { error: objectModule.safeErrorAsJson(error) },
    });
    return false;
  }
};
